const angular = require('angular')
const filter = require('lodash/filter')
const map = require('lodash/map')
const forEach = require('lodash/forEach')

module.exports = [
  '$q',
  '$utils',
  'User',
  'Promise',
  '$rootScope',
  '$translate',
  'LocalStorage',
  'contactListService',
  function ($q, $utils, User, Promise, $rootScope, $translate, LocalStorage, contactListService) {
    // 更多详细内容请查看：http://wiki.mailtech.cn/pages/viewpage.action?pageId=393259
    const _cache = {
      uid: User.getCurrentUser().config.email,
      starUid: User.getCurrentUser().config.email + '_' + 'Star',
      oabContacts: {},
      trustedDomains: null,
      allPabContacts: null,
      allPabGroups: null, // 所有的个人通讯录分组
      searchContacts: null, // 搜索历史，最多为10条。每项的结构为：{keyword: s, result: a}，s代表字符串，a代表数组
      maxMatch: 20, // 目前该参数只对搜索有效
      starDeptContact: {} // 星标部门&星标联系人
    }

    function _resetCache() {
      _cache.uid = User.getCurrentUser().config.email
      _cache.oabContacts = {}
      _cache.trustedDomains = null
      _cache.allPabContacts = null
      _cache.searchContacts = null
      _cache.maxMatch = 20
    }

    /**
     * 根据搜索关键字从缓存中获取结果
     * @param keyword
     * @private
     * @returns 有结果时返回缓存结果，没有时返回null
     */
    function _getCacheSearchContacts(keyword) {
      if (_cache.uid === User.getCurrentUser().config.email && _cache.searchContacts) {
        const result = {}
        for (let idx = 0, size = _cache.searchContacts.length; idx < size; idx++) {
          angular.copy(_cache.searchContacts[idx], result)
          if (result['keyword'] === keyword) {
            return result['result']
          }
        }
      }
      return []
    }

    /**
     * 将搜索结果保存到缓存中。最多缓存10条搜索条件
     * @param keyword
     * @param contacts
     * @private
     */
    function _saveCacheSearchContacts(keyword, contacts) {
      _cache.uid !== User.getCurrentUser().config.email ? _resetCache() : angular.noop()
      _cache.searchContacts = _cache.searchContacts || []

      // 删除之前相同关键字的结果
      for (let idx = 0, size = _cache.searchContacts.length; idx < size; idx++) {
        if (_cache.searchContacts[idx]['keyword'] === keyword) {
          _cache.searchContacts.splice(idx, 1)
          break
        }
      }
      _cache.searchContacts.unshift({ keyword: keyword, result: contacts })
      if (_cache.searchContacts.length > 10) {
        _cache.searchContacts.pop()
      }
    }

    /**
     * 过滤个人通讯录联系人信息
     * @param contacts
     * @private
     */
    function _filterPabContacts(contacts) {
      const result = []
      let email = ''
      let name = ''
      let groups = ''
      let id = ''
      const type = 'pabContact'
      let location = '' // 标识联系人所在分组

      angular.forEach(contacts, function (value, key) {
        email = value['EMAIL;PREF'] || ''
        email = angular.isArray(email) ? email[0] : email
        name = value['FN'] || ''
        groups = value.groups
        id = value.id
        location = value.ORGNAME
        if (angular.isArray(value.groups) && value.groups.length === 0) {
          location = `${$translate.instant('ADDRESSBOOK.PERSONAL_ADDRESS_BOOK')}/${$translate.instant('ADDRESSBOOK.UNGROUPED_CONTACTS')}`
        } else {
          value.groups.forEach(function (item) {
            ($rootScope.personalGroupArr || []).forEach(function (group) {
              if (item === group.id) {
                location = `${$translate.instant('ADDRESSBOOK.PERSONAL_ADDRESS_BOOK')}/${group.name}`
              }
            })
          })
        }
        if ($utils.$email.parse(email)) {
          result.push({ name: name, addr: email, groups: groups, id: id, type: type, location: location })
        }
      })

      return result
    }

    /**
     * 过滤并且格式化组织通讯录联系人信息
     * @param contacts
     * @private
     * @returns 返回格式化的结果，每项的数据结构为
     *           {name: s, addr: s, matchText: s, startIndex: d, matchLength: d}   s代表字符串，d代表数字。以matchText进行匹配
     */
    function _filterOabContacts(contacts, keyword) {
      keyword = $utils.$html.trim(keyword)
      if (!keyword) {
        return contacts
      }
      const result = []
      angular.forEach(contacts, function (value, key) {
        const contact = angular.copy(value)
        let startIndex = -1
        let matchLength = -1
        let matchText = ''
        let matchAgain = false
        const aliasEmail = $utils.$py.filterAliasEmail(contact, keyword)
        if (contact['m']) {
          const match = contact['m'][0].split(':', 3)
          startIndex = parseInt(match[0], 10)
          matchLength = parseInt(match[1], 10)
          matchText = match[2]
          if (startIndex >= 0 && matchLength > 0) {
            if (matchText === contact['true_name']) {
              // matchText = '\"' + contact['true_name'] + '\"' + ' <' + contact['email'] + '>'
              matchText = contact['true_name'] + ' ' + contact['email']
            } else if (matchText === contact['nick_name']) {
              // matchText = '\"' + contact['nick_name'] + '\"' + ' <' + contact['email'] + '>'
              matchText = contact['nick_name'] + ' ' + contact['email']
            } else if (matchText === contact['email']) {
              // matchText = "\"" + (contact["true_name"] || contact["nick_name"] || "") + "\"" + " <" + contact["email"] + ">"
              matchText = (contact['true_name'] || contact['nick_name'] || '') + ' ' + contact['email']
              // startIndex += ("\"" + (contact["true_name"] || contact["nick_name"] || "") + "\"" + " <").length
              startIndex += ((contact['true_name'] || contact['nick_name'] || '') + ' ').length
            } else {
              // matchText = $utils.$email.test(matchText) ?
              //    ("\"" + (contact["true_name"] || contact["nick_name"] || "") + "\"" + " <" + contact["email"] + ">") :
              //    ("\"" + (contact["true_name"] || contact["nick_name"] || matchText || "") + "\"" + " <" + contact["email"] + ">")
              matchText = $utils.$email.test(matchText)
                ? ((contact['true_name'] || contact['nick_name'] || '') + ' ' + (aliasEmail || contact['email']))
                : ((contact['true_name'] || contact['nick_name'] || matchText || '') + ' ' + (aliasEmail || contact['email']))
              matchAgain = true
            }
          } else {
            // matchText = $utils.$email.test(matchText) ?
            //    ("\"" + (contact["true_name"] || contact["nick_name"] || "") + "\"" + " <" + contact["email"] + ">") :
            //    ("\"" + (contact["true_name"] || contact["nick_name"] || matchText || "") + "\"" + " <" + contact["email"] + ">")
            matchText = $utils.$email.test(matchText)
              ? ((contact['true_name'] || contact['nick_name'] || '') + ' ' + (aliasEmail || contact['email']))
              : ((contact['true_name'] || contact['nick_name'] || matchText || '') + ' ' + (aliasEmail || contact['email']))
            matchAgain = true
          }
        } else {
          // matchText = "\"" + (contact["true_name"] || contact["nick_name"] || "") + "\"" + " <" + contact["email"] + ">"
          matchText = (contact['true_name'] || contact['nick_name'] || '') + ' ' + (aliasEmail || contact['email'])
          matchAgain = true
        }

        matchText = $utils.$html.encode(matchText)

        // 如果服务器返回结果的匹配信息不正确，退化为客户端再匹配一次
        if (matchAgain && $utils.$py.indexOf(matchText, keyword) > -1) {
          angular.extend(contact, $utils.$py.match(matchText, keyword, null))
          startIndex = contact['startIndex']
          matchLength = contact['matchLength']
        }
        if (!matchAgain || (contact['startIndex'] !== undefined || aliasEmail)) {
          result.push(angular.copy({
            name: contact['true_name'] || contact['nick_name'] || $utils.$email.parse(matchText).name || '',
            addr: contact['email'],
            location: reverseData(contact['location']),
            startIndex: startIndex,
            matchLength: matchLength,
            matchText: matchText
          }))
        }
      })

      return result
    }
    // 组织结构顺序反转
    function reverseData(data) {
      return data.split('/').reverse().join('/')
    }

    /**
     * 合并联系人
     * @param pabContacts   个人通讯录的联系人
     * @param oabContacts   组织通讯录的联系人
     * @private
     */
    function _mergeContacts(pabContacts, oabContacts) {
      const result = angular.copy(pabContacts)

      angular.forEach(oabContacts, function (value, key) {
        result.push(angular.copy(value))
      })
      return result
    }

    /**
     * 高亮显示联系人信息
     * @param contacts
     *          单项联系人匹配的可能如下：
     *          matchText                   startIndex      matchLength     匹配结果                    期望输出
     *          "abc" <abc@coremail.cn>         1               2           "xxc" <abc@coremail.cn>     "<b>ab</b>c" &lg;abc@coremail.cn&gt;
     *          "" <abc@coremail.cn>            4               2           "" <xxc@coremail.cn>        "" &lt;<b>ab</b>c@coremail.cn&gt;
     *          abc                             1               2           xxc                         <b>ab</b>c
     * @param style     一个样式对象，如果为空对象，只会添加<b>标签到需要高亮的内容
     * @private
     */
    function _hightLightContacts(contacts, style) {
      if (!style) {
        return contacts
      }
      let styleText = ''
      if ($utils.$html.isEmptyObject(style)) {
        styleText = '<b>'
      } else {
        styleText = "<b class='highlight' style=\""
        angular.forEach(style, function (value, key) {
          styleText += key + ':' + value + ';'
        })
        // styleText = styleText + "color:#12ac24;"
        styleText += '">'
      }
      const results = []
      angular.forEach(contacts, function (value, key) {
        const contact = angular.copy(value)
        if (contact.matchText && (contact.startIndex > -1) && (contact.matchLength > 0)) {
          contact.matchText = $utils.$html.decode(contact.matchText)
          const nameIndex = contact.matchText.indexOf(' ')
          const styleName = '<b style="color:#222">'
          let text
          if (nameIndex < contact.startIndex) {
            text = styleName + $utils.$html.encode(contact.matchText.substring(0, nameIndex)) + '</b>' +
              $utils.$html.encode(contact.matchText.substring(nameIndex, contact.startIndex)) + styleText +
              $utils.$html.encode(contact.matchText.substr(contact.startIndex, contact.matchLength)) + '</b>' +
              $utils.$html.encode(contact.matchText.substring(contact.startIndex + contact.matchLength))
          } else {
            text = styleName + $utils.$html.encode(contact.matchText.substring(0, contact.startIndex)) + styleText +
              $utils.$html.encode(contact.matchText.substr(contact.startIndex, contact.matchLength)) + '</b>' +
              $utils.$html.encode(contact.matchText.substring(contact.startIndex + contact.matchLength, nameIndex + 1)) + '</b>' +
              $utils.$html.encode(contact.matchText.substring(nameIndex))
          }
          contact.matchText = text
          results.push(angular.copy(contact))
        }
      })
      return results
    }

    /* --------------------------------PUBLIC METHOD--------------------------------- */
    /**
     * 获取用户个人通讯录的所有联系人
     * @returns 返回的数据为一个联系人数组，每个联系人信息为一个对象，包含name和addr属性
     */
    function getAllPabContacts() {
      const deferred = $q.defer()
      Promise.wmCall('pab:searchContacts', {
        order: [
          {
            field: 'FN',
            ignoreCase: true
          }
        ]
      }).then(function (data) {
        if (data.code === 'S_OK') {
          // 过滤联系人信息
          const contacts = _filterPabContacts(data.var)
          deferred.resolve(contacts)
        } else {
          deferred.reject(data.code)
        }
      })
      return deferred.promise
    }
    /**
     * 获取个人通讯录指定分组下的联系人
     * @param groupid 分组ID
     * @returns 返回的是该分组下的联系人数组
     */
    function getGroupPabContacts(groupid) {
      const deferred = $q.defer()
      const temp = []
      if (groupid !== 'OTHER' && groupid !== 'ALLPERSONALCONTACTS') {
        temp.push(groupid)
      }
      Promise.wmCall('pab:searchContacts', {
        returnAttrs: ['FN', 'id', 'groups', 'EMAIL;PREF'],
        groups: temp
      }).then(function (data) {
        if (data.code === 'S_OK') {
          // 未分组联系人通过所有联系人过滤有分组联系人获得
          if (groupid === 'OTHER') {
            const tempResult = []
            data.var.forEach(function (item) {
              if (item.groups.length === 0) {
                tempResult.push(item)
              }
            })
            data.var = tempResult
          }
          // 过滤联系人信息
          const contacts = _filterPabContacts(data.var)
          deferred.resolve(contacts)
        } else {
          deferred.reject(data.code)
        }
      })

      return deferred.promise
    }
    /**
     * 获取个人通讯录联系人详情
     * @param contactid 联系人id
     * @returns 返回的是联系人详情对象
     */
    function getContactDetail(contactid) {
      const deferred = $q.defer()
      Promise.wmCall('pab:getContacts', {
        ids: [contactid]
      }).then(function (data) {
        if (data.code === 'S_OK') {
          deferred.resolve(data.var[0])
        }
      }, function (error) {
        console.log(error)
        deferred.reject('fail')
      })
      return deferred.promise
    }
    /**
     * 创建个人通讯录新联系人
     * @param contactDetail 联系人详情对象
     * @returns 成功创建返回success,创建失败返回fail
     */
    function createPabContact(contactDetail) {
      const deferred = $q.defer()
      Promise.wmCall('pab:createContacts', {
        items: [contactDetail]
      }).then(function (data) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    /**
     * 删除个人通讯录指定联系人
     * @param id  联系人id
     * @returns 成功创建返回success,创建失败返回fail
     */
    function deleteContactById(id) {
      const deferred = $q.defer()
      const params = {
        ids: [id]
      }
      Promise.wmCall('pab:deleteContacts', params).then(function (data) {
        if (data.code === 'S_OK') {
          deferred.resolve('success')
        }
      }, function () {
        deferred.resolve('fail')
      })
      return deferred.promise
    }
    /**
     * 更新个人通讯录联系人详情
     * @param contactDetail 联系人详情对象
     * @returns 成功更新返回success,更新失败返回fail
     */
    function updatePabContactDetail(contactDetail) {
      const deferred = $q.defer()
      Promise.wmCall('pab:updateContacts', {
        items: [contactDetail]
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    /**
     * 根据关键词搜索个人通讯录联系人
     * 参照webmail实现，关键字搜索只匹配邮件地址，姓名，手机号
     * 这里不将结果缓存的原因是如果搜索到的某一个联系人隶属于某一个未访问过的分组的话，那在进入该分组的
     * 话就会导致获取到的分组联系人列表不是正确的列表，这是由于getGroupPabContacts的处理逻辑导致的
     * @param keyword 搜索关键字
     * @returns 返回搜索结果的联系人数组
     */
    function findPabContacts(keyword) {
      const deferred = $q.defer()
      const params = {
        returnAttrs: ['FN', 'EMAIL;PREF', 'ORGNAME', 'id'],
        operator: 'or',
        condictions: [
          {
            field: 'FN',
            operator: 'contains',
            operand: keyword,
            ignoreCase: true
          },
          {
            field: 'TEL;CELL;VOICE',
            operator: 'contains',
            operand: keyword,
            ignoreCase: true
          },
          {
            field: 'EMAIL;PREF',
            operator: 'contains',
            operand: keyword,
            ignoreCase: true
          }
        ],
        order: {
          field: 'FN'
        }
      }
      Promise.wmCall('pab:searchContacts', params).then(function (data) {
        if (data.code === 'S_OK') {
          data.var.forEach(function (item) {
            item.type = 'pabContact'
          })
          deferred.resolve(data.var)
        }
      }, function (error) {
        console.log(error)
        deferred.reject('fail')
      })
      return deferred.promise
    }
    /**
     * 根据email搜索特定的联系人
     * @param email 邮箱地址
     * @returns 成功返回该联系人id,失败返回fail
     */
    function searchPabContactByEmail(email) {
      const deferred = $q.defer()
      const params = {
        returnAttrs: ['id'],
        condictions: [
          {
            field: 'EMAIL;PREF',
            operator: '=',
            operand: email,
          },
        ],
        order: {
          field: 'FN'
        }
      }
      Promise.wmCall('pab:searchContacts', params).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    /**
     * 自动匹配组织通讯录的联系人
     * @param keyword   搜索关键字，如果为空直接返回空数组
     * @param limit     匹配的数量，默认为20，最大也是20
     */
    function autoMatchOabContacts(keyword, limit) {
      const deferred = $q.defer()
      keyword = $utils.$html.trim(keyword)
      limit = (limit > 0 && limit <= _cache.maxMatch) ? limit : _cache.maxMatch

      if (!keyword) {
        deferred.resolve([])
      } else {
        const enableVirtualUserAC = $rootScope.settings.contact.oab.enableVirtualUserAC
        Promise.wmCall('oab:autoMatch', {
          limit: limit,
          keyword: keyword,
          '@type': enableVirtualUserAC ? 'U,L,X,D' : 'U,L,X',
          attrIds: ['m', 'location'],
          enableNickNameAC: true,
          enableVirtualUserAC,
          enableAliasAC: true
        }).then(function (data) {
          deferred.resolve(_filterOabContacts(data.var, keyword))
        }, function (data) {
          deferred.reject(data)
        })
      }
      return deferred.promise
    }
    /**
     * 列举组织通讯录部门列表
     * @param {string} dn 部门
     */
    function listOabDepartments(dn) {
      const params = {
        dn,
        attrIds: ['name', 'email']
      }
      return contactListService.getAddress(params).then(function(data) {
        if (data.code !== 'S_OK' || !data.var) return $q.reject(data)

        angular.forEach(data.var.ou || [], function(item) {
          item.type = 'oabDepartment'
          item.avatar = 'icon-icongroup'
        })
        if (angular.isArray(data.var)) {
          data.var[0].avatar = 'icon-icongroup'
          data.var[0].type = 'oabDepartment'
        }
        return data
      })
    }
    /**
     * 搜索组织通讯录的联系人
     * @param {string} keyword 搜索关键字
     * @param {string} dn 搜索的组织
     */
    function searchOabContacts(keyword, dn) {
      const avatarType = {
        'D': 'icon-icongroup',
        'L': 'icon-iconmaillist',
        'U': 'icon-iconman',
        'X': 'icon-iconman',
        'R': 'icon-icon_meeting'
      }
      const enableVirtualUserAC = $rootScope.settings.contact.oab.enableVirtualUserAC
      return Promise.wmCall('oab:autoMatch', {
        dn: dn,
        limit: 500,
        '@type': enableVirtualUserAC ? 'U,L,X,D' : 'U,L,X',
        attrIds: '@id',
        keyword
      }).then(res => {
        return Promise.wmCall('oab:get', {
          list: map(res.var, item => item['@id'] || item['email']),
          returnAttrs: ['@id', '@type', 'company_phone', 'true_name', 'email', 'mobile_number', 'duty', '@ou', '@location', 'gender']
        }).catch(e => res) // 兼容异常情况，返回 autoMatch 结果
      }).then(res => {
        // S_PARTIAL_OK
        return map(filter(res.var), item => {
          item.type = 'oabContact'
          avatarType[item['@type']] && (item.avatar = avatarType[item['@type']] || '')
          if (item['@location']) {
            item.reverseLocation = reverseData(item['@location'])
          }
          return item
        })
      })
    }
    /**
     * 搜索个人通讯录的联系人
     * @param {string} keyword 搜索关键字
     */
    function searchPabContacts(keyword) {
      const deferred = $q.defer()
      const params = {
        operator: 'or',
        condictions: [
          { field: 'FN', operator: 'contains', operand: keyword },
          { field: 'EMAIL;PREF', operator: 'contains', operand: keyword },
          { field: 'TEL;CELL;VOICE', operator: 'contains', operand: keyword }]
      }
      Promise.wmCall('pab:searchContacts', params).then(function (data) {
        if (data.code === 'S_OK') {
          data.var.forEach(function(contact) {
            if (angular.isArray(contact.groups) && contact.groups.length === 0) {
              contact.location = `${$translate.instant('ADDRESSBOOK.PERSONAL_ADDRESS_BOOK')}/${$translate.instant('ADDRESSBOOK.UNGROUPED_CONTACTS')}`
            } else {
              contact.groups.forEach(function (item) {
                forEach($rootScope.personalGroupArr, function (group) {
                  if (item === group.id) {
                    contact.location = `${$translate.instant('ADDRESSBOOK.PERSONAL_ADDRESS_BOOK')}/${group.name}`
                  }
                })
              })
            }
            if (contact.location) {
              contact.reverseLocation = reverseData(contact.location)
            }
            contact.type = 'pabContact'
          })
          deferred.resolve(data.var)
        }
      }, function () {
        deferred.reject()
      })
      return deferred.promise
    }

    /**
     * 搜索个人通讯录的联系人
     * @param keyword   搜索关键字，如果为空直接返回空数组
     * @param limit     匹配的数量，默认为20，最大也是20
     * @returns 没有结果时返回空数组。有结果时返回数组，数组中每项的结构为：
     *           {name: s, addr: s, matchText: s, startIndex: d, matchLength: d}   s代表字符串，d代表数字。以matchText进行匹配
     */
    function searchPabContacts_(keyword, limit) {
      const deferred = $q.defer()
      keyword = $utils.$html.trim(keyword)
      limit = (limit > 0 && limit <= _cache.maxMatch) ? limit : _cache.maxMatch

      if (!keyword) {
        deferred.resolve([])
      } else {
        getAllPabContacts(true).then(function (contacts) {
          const results = []
          const contact = {}
          let matchText = ''

          for (let idx = 0, size = contacts.length; idx < size && results.length < limit; idx++) {
            angular.copy(contacts[idx], contact)
            // matchText = "\"" + contact.name + "\"" + "<" + contact.addr + ">";
            matchText = $utils.$html.encode(contact.name + ' ' + contact.addr)

            if ($utils.$py.indexOf(matchText, keyword) > -1) {
              angular.extend(contact, { matchText: matchText }, $utils.$py.match(matchText, keyword, null))
              // contact.startIndex = contact.startIndex -1 ;
              contact.startIndex = contact.startIndex

              results.push(angular.copy(contact))
            }
          }
          deferred.resolve(results)
        }, function (data) {
          deferred.reject(data)
        })
      }

      return deferred.promise
    }

    /**
     * 搜索联系人
     * 处理逻辑：优先从个人通讯录中搜索，如果数量满足，返回处理结果；
     *           如果数量不满足，从组织通讯录中搜索剩余联系人，冗余10条数据。再合并个人通讯录的结果返回。
     *           搜索组织通讯录时增加冗余数据是为了略微预防个人通讯录的结果覆盖组织通讯录的结果
     * @param keyword   搜索关键字，如果为空直接返回空数组
     * @param cache     是否从缓存中读取结果，默认为true。此处建议优先从缓存中获取结果。以后可能会屏蔽该参数
     * @param style     Object, 用于控制高亮输出结果。
     * @returns 返回联系人数组，每项联系人数据结构为：
     *              {name: s, addr: s, matchText: s, startIndex: d, matchLength: d}   s代表字符串，d代表数字。以matchText进行匹配
     */
    function searchContacts(keyword, cache, style) {
      const deferred = $q.defer()
      keyword = $utils.$html.trim(keyword)
      cache = typeof cache === 'boolean' ? cache : true

      const cacheSearchContacts = _getCacheSearchContacts(keyword)
      if (!keyword) {
        deferred.resolve([])
      } else if (cache && cacheSearchContacts.length !== 0) {
        deferred.resolve(cacheSearchContacts)
      } else {
        // 搜索个人通讯录
        searchPabContacts_(keyword, _cache.maxMatch).then(function (pabContacts) {
          // remove redundant self contacts
          const existed = {}
          pabContacts = filter(pabContacts, item => {
            const isExisted = existed[item.addr]
            existed[item.addr] = true
            return isExisted
          })
          if (pabContacts.length >= _cache.maxMatch) { // 满足数量，返回结果
            // 高亮匹配结果
            const results = _hightLightContacts(pabContacts, style)
            // 缓存搜索结果
            _saveCacheSearchContacts(keyword, pabContacts)
            deferred.resolve(results)
          } else { // 不满足数量，接着搜索组织通讯录
            autoMatchOabContacts(keyword, _cache.maxMatch - pabContacts.length + 10).then(function (oabContacts) {
              let contacts = _mergeContacts(pabContacts, oabContacts)
              contacts = _hightLightContacts(contacts, style)
              _saveCacheSearchContacts(keyword, contacts)
              deferred.resolve(contacts)
            }, function (data) {
              deferred.reject(data)
            })
          }
        }, function (data) {
          deferred.reject(data)
        })
      }

      return deferred.promise
    }
    // 获取组织通讯录联系人信息
    function getOabContact(contactId) {
      const deferred = $q.defer()
      Promise.wmCall('oab:get', {
        list: contactId,
        returnAttrs: ['true_name', '@id', 'email', '@ou', '@type', '@list', 'mobile_number', 'home_phone', 'duty', 'company_phone', 'fax_number', '@location']
      }).then(function (data) {
        const contact = data.var[0] || {}
        deferred.resolve(contact)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    // 列举组织通讯录联系人
    function listEx(dn, start, limit) {
      const avatarType = {
        'D': 'icon-icongroup',
        'L': 'icon-iconmaillist',
        'U': 'icon-iconman',
        'X': 'icon-iconman',
        'R': 'icon-icon_meeting'
      }
      const defaultReturnMeetingRoom = $rootScope.settings.contact.oab.defaultReturnMeetingRoom
      const params = {
        dn: dn,
        returnAttrs: ['email', '@id', 'true_name', '@ou', '@type'],
        start: start,
        limit: limit,
        defaultReturnMeetingRoom
      }
      return Promise.wmCall('oab:listEx', params).then(function (data) {
        if (data.code !== 'S_OK' || !data.var) return $q.reject(data)

        angular.forEach(data.var || [], function (item) {
          item.avatar = avatarType[item['@type']] || item.avatar
          item.type = 'oabContact'
        })
        return data
      })
    }
    /**
     *  通过pab:getAllGroups获取不包含未分组联系人分组的个人通讯录分组数组
     *  并缓存下来
     */
    function getAllPabGroups() {
      const deferred = $q.defer()
      Promise.wmCall('pab:getAllGroups').then(function (data) {
        if (data.code === 'S_OK') {
          _cache.allPabGroups = data.var
          deferred.resolve(data.var)
        }
      }, function (data) {
        deferred.reject(data)
      })
      return deferred.promise
    }
    /**
       *  获取个人通讯录分组，返回的分组中手动加入了未分组联系人和所有联系人
       */
    function getPersonalGroups() {
      const deferred = $q.defer()
      const injectVirtulGroups = function (groups) {
        const other = {
          id: 'OTHER',
          name: $translate.instant('ADDRESSBOOK.UNGROUPED_CONTACTS'),
          reserved: true,
          rev: 0
        }
        const allPersonalContacts = {
          id: 'ALLPERSONALCONTACTS',
          name: $translate.instant('ADDRESSBOOK.ALL_PERSONAL_CONTACTS'),
          reserved: true,
          rev: 0
        }
        groups.push(other)
        groups.unshift(allPersonalContacts)
      }
      let groupArr
      getAllPabGroups().then(function (groups) {
        if (groups) {
          groupArr = groups
          injectVirtulGroups(groupArr)
          groupArr.forEach(function (item) {
            item.type = 'pabGroup'
          })
          $rootScope.personalGroupArr = groupArr
          deferred.resolve(groupArr)
        }
      }, function (error) {
        console.log(error)
        deferred.reject([])
      }).finally(function () {
      })
      return deferred.promise
    }
    /**
     * 获取星标部门或星标联系人列表
     * @param type    department: 部门 contact: 联系人
     * @returns 返回星标部门数组或星标联系人列表，为空时返回空数组
     */
    function getStarDeptContact(type) {
      const deferred = $q.defer()
      if (!type || (type !== 'department' && type !== 'contact')) deferred.reject([])
      else {
        _cache.starDeptContact = LocalStorage.getItem(_cache.starUid)
        if (JSON.stringify(_cache.starDeptContact) === '{}') {
          deferred.reject([])
        } else {
          deferred.resolve(_cache.starDeptContact[type] ? _cache.starDeptContact[type] : [])
        }
      }
      return deferred.promise
    }
    /**
    * 判断是否是星标联系人或星标部门
    * @param params 包含id和判断类型type
    * @returns 返回布尔值表示是否已设为星标
    */
    function isStarDeptContact(params) {
      if (!params) return false
      if (params.id && params.type) {
        let isStar = false
        _cache.starDeptContact = LocalStorage.getItem(_cache.starUid)
        if (_cache.starDeptContact[params.type]) {
          _cache.starDeptContact[params.type].forEach(function (item) {
            if (item.id === params.id) isStar = true
          })
        }
        return isStar
      } else {
        return false
      }
    }
    /**
     * 标记为星标联系人或星标部门
     * @param params 参数对象，传递包含两个参数：type-表示部门或联系人(department&contact), payload-表示携带的部门或联系人信息
     * @returns 返回布尔值表示操作成功或失败
     */
    function markStar(params) {
      const deferred = $q.defer()
      if (!params) deferred.reject(false)
      if (params.type && params.payload) {
        _cache.starDeptContact = LocalStorage.getItem(_cache.starUid)
        _cache.starDeptContact[params.type] = _cache.starDeptContact[params.type] || []
        _cache.starDeptContact[params.type].push(params.payload)
        LocalStorage.setItem(_cache.starUid, _cache.starDeptContact)
        deferred.resolve(true)
      } else {
        deferred.reject(false)
      }
      return deferred.promise
    }
    /**
     * 取消星标联系人或星标部门
     * @param params 参数对象，传递包含两个参数：type-表示部门或联系人(department&contact), id-表示部门id或联系人id
     * @returns 返回布尔值表示操作是否成功
     */
    function removeStar(params) {
      const deferred = $q.defer()
      if (!params) deferred.reject(false)
      if (params.type && params.id) {
        _cache.starDeptContact = LocalStorage.getItem(_cache.starUid)
        let removeIndex
        _cache.starDeptContact[params.type].forEach(function (item, index) {
          if (item.id === params.id) {
            removeIndex = index
          }
        })
        _cache.starDeptContact[params.type].splice(removeIndex, 1)
        LocalStorage.setItem(_cache.starUid, _cache.starDeptContact)
        deferred.resolve(true)
      } else {
        deferred.reject(false)
      }
      return deferred.promise
    }
    /**
     * 获取组织架构
     * @param params 参数对象 传递包含两个参数dn,attrIds, dn传递空值返回完整架构树, attrIds表示要求返回的额外属性集，目前仅支持一个，具体查看接口文档
     * @returns 返回获取到的组织架构对象
     */
    function getOabStructureBydn(params) {
      const deferred = $q.defer()
      if (!params || !params.dn) deferred.reject({})
      const { dn, attrIds } = params
      if (dn) {
        contactListService.getAddress({
          dn,
          attrIds: attrIds || ''
        }).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve(data.var)
          }
        }, function () {
          deferred.reject({})
        })
      }
      return deferred.promise
    }

    // 获取可信任域名(site:getTrustedDomains = site:getAllDomains + 配置上的信任域名的集合)
    function getCacheTrustedDomains() {
      if (_cache.uid !== User.getCurrentUser().config.email) _resetCache()
      if (_cache.trustedDomains) return $q.resolve(_cache.trustedDomains)

      return Promise.wmCall('site:getTrustedDomains').then(res => {
        if (res.code !== 'S_OK') return $q.reject(res)

        _cache.trustedDomains = res.var || []
        return _cache.trustedDomains
      }, err => {
        // TODO: 该接口尚未产品化，如果失败则跳过
        if (err.code !== 'FR_INVALID_REQUEST') return $q.reject(err)

        _cache.trustedDomains = []
        return _cache.trustedDomains
      })
    }

    // 获取个人通讯录列表
    function getCachedPabContacts() {
      if (_cache.uid !== User.getCurrentUser().config.email) _resetCache()
      if (_cache.allPabContacts) return $q.resolve(_cache.allPabContacts)

      return Promise.wmCall('pab:searchContacts', {
        returnAttrs: ['id', 'FN', 'EMAIL;PREF']
      }).then(res => {
        if (res.code !== 'S_OK') return $q.reject(res)

        _cache.allPabContacts = res.var || []
        return _cache.allPabContacts
      })
    }

    /**
     * 收件人是否是陌生人(依赖 getCacheTrustedDomains, getCachedPabContacts 的结果)
     * 非陌生人：本组织的域名、配置里的域名（白名单）、个人通讯录地址
     * @param mail 收件人的邮件地址
     * @returns 返回是否是陌生人 true/false
     */
    function isStranger(email) {
      const address = $utils.$email.parse(email).addr
      if (!address) return false

      const strangerConfig = $rootScope.settings.mail.stranger
      if (!strangerConfig.enable) return false

      // 为了防止混乱，无缓存则返回false，不显示陌生人
      if (!_cache.trustedDomains || !_cache.allPabContacts) return false

      const ignoreDomains = strangerConfig.ignoreDomains ? strangerConfig.ignoreDomains.split(/\s*,\s*/) : [] // hxphone配置里的域名（白名单）
      const config = User.getCurrentUser().config || {}
      const domain = config.email ? config.email.split('@') : []
      let allOrgDomains = domain[1] ? ignoreDomains.concat(domain[1]) : ignoreDomains// 所有可信任域名
      let allPabContacts = [] // 个人通讯录邮件地址列表

      allOrgDomains = allOrgDomains.concat(_cache.trustedDomains)
      allPabContacts = map(_cache.allPabContacts, item => item['EMAIL;PREF'])

      const allowDomainsReg = new RegExp(`@(${allOrgDomains.join('|')})$`, 'i')
      return !allowDomainsReg.test(address) && !~allPabContacts.indexOf(address)
    }

    return {
      getOabContact: getOabContact,
      getAllPabContacts: getAllPabContacts,
      autoMatchOabContacts: autoMatchOabContacts,
      searchOabContacts: searchOabContacts,
      searchPabContacts: searchPabContacts,
      searchContacts: searchContacts,
      getAllPabGroups: getAllPabGroups,
      getGroupPabContacts: getGroupPabContacts,
      getContactDetail: getContactDetail,
      updatePabContactDetail: updatePabContactDetail,
      createPabContact: createPabContact,
      findPabContacts: findPabContacts,
      deleteContactById: deleteContactById,
      searchPabContactByEmail: searchPabContactByEmail,
      getPersonalGroups: getPersonalGroups,
      getStarDeptContact: getStarDeptContact,
      isStarDeptContact: isStarDeptContact,
      markStar: markStar,
      removeStar: removeStar,
      getOabStructureBydn: getOabStructureBydn,
      listEx: listEx,
      listOabDepartments: listOabDepartments,
      getCacheTrustedDomains: getCacheTrustedDomains,
      getCachedPabContacts: getCachedPabContacts,
      isStranger: isStranger
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/services/contactService.js